"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generatePresets = void 0;

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var generatePresets = function generatePresets() {
  var nextMonday = (0, _momentTimezone.default)().tz('US/Eastern').day('Monday').day() + ((0, _momentTimezone.default)().day() >= 1 ? 7 : 0);
  var presets = [{
    name: 'Tomorrow morning',
    time: (0, _momentTimezone.default)().tz('US/Eastern').add(1, 'day').set({
      hours: 10,
      minutes: 0,
      seconds: 0
    })
  }, {
    name: 'Tomorrow afternoon',
    time: (0, _momentTimezone.default)().tz('US/Eastern').add(1, 'day').set({
      hours: 13,
      minutes: 0,
      seconds: 0
    })
  }, {
    name: 'Monday morning',
    time: (0, _momentTimezone.default)().tz('US/Eastern').day(nextMonday).set({
      hours: 10,
      minutes: 0,
      seconds: 0
    })
  }];
  return {
    presets,
    timeZoneName: {
      EDT: 'Eastern Daylight Time',
      EST: 'Eastern Standard Time'
    }[presets[0].time.format('z')]
  };
};

exports.generatePresets = generatePresets;